// extracted by mini-css-extract-plugin
module.exports = {"md":"CatalogTabbarSlot_md_3-1oH","ios":"CatalogTabbarSlot_ios_M5Dtq","slot":"CatalogTabbarSlot_slot_3Pojo"};